<template>
  <!--
  <right-menu-item
    v-if="show && bcDocumentStore.edit"
    @click.prevent="edit"
    :class="{ 'muted': !active }"
    :text="$t('Edit in canva')"
    :loading="loading"
    icon="canva"
    icon-class=""
  />
  -->
  
  <a :href="canvaRemixUrl" target="_blank" :class="{'muted': !active }" v-if="show" @click="remix">
    <aw-icon icon="canva" class="w-5 h-5 "></aw-icon>
    {{$t('Use Canva template')}}
  </a>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { editDesign } from '../../mixins/actions/Canva'
import { trackEvent } from '../../gtm'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show() {
      for (let el of this.bcSelectedStore.selectableMap.values()) {
        if (el.type === 'file' && el.file?.id_canva_design) {
          return true
        }
      }

      return false
    },
    active () {
      return this.listCanva.length === 1
        && this.listCanva[0].file.id_canva_design
    },
    listCanva () {
      if (this.bcSelectedStore.listFullySelected.length) {
        if (this.bcSelectedStore.listFullySelected.every((el) => {
          return el.type === 'file'
            && el.file.id_canva_design
        })) {
          return this.bcSelectedStore.listFullySelected
        }

        return []
      
      } else {
        return [...this.bcSelectedStore.selectableMap.values()].filter((el) => {
          return el.type === 'file'
            && el.file.id_canva_design
        })
      }
    },
    canvaRemixUrl() {
      return this.active
        ? 'https://canva.com/design/' + this.listCanva[0].file.id_canva_design + '/remix'
        : ''
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    remix() {
      trackEvent(this.$route.matched[0].name, 'canvaRemix', this.listCanva[0].file.id_canva_design)
    },
    async edit() {
      this.loading = true
      const element = this.listCanva[0]
      trackEvent(this.$route.matched[0].name, 'canvaEdit', element.file.id_canva_design)
      const canvaFile = await editDesign(
        element.file.id_canva_design,
        element.file.file_ext,
        {
          documentId: this.bcDocumentStore.document.id,
          folderId: this.bcDocumentStore.document.bc_folder_id,
          elementId: element.id,
        }
      )

      this.loading = false
      
      if (!canvaFile.file) {
        return
      }

      const elementParent = this.bcDocumentStore.findElementInDocument(element.id)
      elementParent.children.push({
        parent__bc_document_data_rev_id: elementParent.id,
        type: 'file',
        data: {
          name: '',
          canva: true,
          can_download: true,
          public_upload: false,
          file_id: canvaFile.file.id,
          canva_design: {
            ...(elementParent.data.canva_design || {}),
            design_id: canvaFile.designId,
            file_type: canvaFile.file.ext
          }
        },
        file: canvaFile.file,
        rank: elementParent.children.length,
        updated: true,
        key: Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, '')
          .substr(0, 5)
      })

      this.bcSelectedStore.reload()
    }
  }
}
</script>

<style lang="scss" scoped></style>
